import { neonClient } from './neon';
import { neonAuthClient } from './neonAuthClient';
import { r2Storage } from './neonStorage';

/**
 * Supabase Compatibility Proxy
 * This redirects existing Supabase calls to Neon and Cloudflare R2.
 */
export const supabase = {
  from: (tableName) => neonClient.from(tableName),
  auth: neonAuthClient,
  storage: r2Storage,
};

// Test connection helper
export const testSupabaseConnection = async () => {
  try {
    const { data, error } = await neonClient?.from('lasea_users')?.select('id')?.limit(1);
    return !error;
  } catch (err) {
    console.error('Neon connection error:', err);
    return false;
  }
};
